import { ICommonAppState } from "@xala/common-services";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { withScreenDesignerContext } from "../../context";
import {
  ApplicationMenuItemPreview as ApplicationMenuItemPreviewDefinition,
  IApplicationMenuItemPreviewDispatchProps,
  IApplicationMenuItemPreviewOwnProps,
  IApplicationMenuItemPreviewStateProps,
} from "./ApplicationMenuItemPreview";

const mapStateToProps = (
  state: ICommonAppState
): IApplicationMenuItemPreviewStateProps => {
  return {};
};

const mapDispatchToProps = (
  dispatch: Dispatch
): IApplicationMenuItemPreviewDispatchProps => ({});

export const ApplicationMenuItemPreview = connect<
  IApplicationMenuItemPreviewStateProps,
  IApplicationMenuItemPreviewDispatchProps,
  IApplicationMenuItemPreviewOwnProps,
  ICommonAppState
>(
  mapStateToProps,
  mapDispatchToProps
)(
  withTranslation()(
    withScreenDesignerContext(ApplicationMenuItemPreviewDefinition)
  )
);
